// WAP Phase 2 (S4.1) — persisted org branding (for instant apply on boot to avoid a
// flash of the generic theme for returning branded farmers, and for components — e.g.
// header/splash logo — to consume the bank's logo/name). Mirrors userStore's pattern.
import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { OrgBranding } from "@/lib/branding";

interface BrandingStore {
  organizationId: string | null;
  branding: OrgBranding | null;
  setBranding: (organizationId: string | null, branding: OrgBranding | null) => void;
  clear: () => void;
}

export const useBrandingStore = create<BrandingStore>()(
  persist(
    (set) => ({
      organizationId: null,
      branding: null,
      setBranding: (organizationId, branding) => set({ organizationId, branding }),
      clear: () => set({ organizationId: null, branding: null }),
    }),
    { name: "org-branding-storage" }
  )
);
